// Only known recording routes may be restored after login; never follow external destinations.
export const recordReturnPath = (path) =>
  typeof path === "string" && path === path.trim() && /^\/intime-record(?:-test|-examine)?\/(?:hls|youtube|hls-url|nas)$/.test(path)
    ? path
    : "/intime-record/hls";
